import { ProfileForm } from "../components/ProfileForm";
import { useGymProfile } from "../hooks/useGymProfile";

export function ProfileSetupPage() {
  const { isComplete } = useGymProfile();

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>{isComplete ? "Your profile" : "Complete your profile"}</h1>
          <p className="page-sub">
            {isComplete
              ? "Update your details below."
              : "We need a few details before your first booking."}
          </p>
        </div>
      </header>

      <div className="form-card">
        <ProfileForm />
      </div>
    </div>
  );
}
